/**
 * Generate Node Component
 *
 * Node for generating new images from text prompts.
 */

import { memo } from 'react';
import { type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData } from '@/types/imageWorkflow';

const GenerateNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;

  return (
    <BaseNode id={id} data={nodeData} type="generate" selected={selected}>
      {nodeData.prompt ? (
        <div className="space-y-1">
          <div className="text-gray-500">Prompt:</div>
          <div className="line-clamp-2 text-gray-700">{String(nodeData.prompt)}</div>
          {nodeData.model && nodeData.model !== 'auto' && (
            <div className="text-gray-400 mt-1">Model: {String(nodeData.model)}</div>
          )}
          {nodeData.aspect_ratio && (
            <div className="text-gray-400">Ratio: {String(nodeData.aspect_ratio)}</div>
          )}
        </div>
      ) : (
        <div className="text-gray-400 italic">Click to configure prompt</div>
      )}
    </BaseNode>
  );
};

export const GenerateNode = memo(GenerateNodeComponent);
export default GenerateNode;
